//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "ProductTab",
  props: ["value", "refData"],
  components: {},
  mounted: function() {
    this.validateData();
  },
  data: function() {
    return {
      moment,
      validForm: false,
      hierarchyLevels: [],
      hierarchyLevelElements: [],
      aggregatorList: [{id: null, name: "Sem Agregador"}].concat(this.refData)
    };
  },
  methods: {
    required,
    noValidation,
    validateData: function() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData() {
      if (this.value.classificationLevel > 1) {
        this.value.classificationAgregatorLevel = this.hierarchyLevels[
          this.value.classificationLevel - 2
        ].name;
      }

      this.$emit("value", this.value);
    }
  },
  watch: {
    "value.hierarchy": {
      immediate: true,
      deep: true,
      handler: function() {
        BackendServices.getProductHierarchyLevels().then(({ data }) => {
          this.hierarchyLevels = data;
          if (!this.hierarchyLevelElements.length) {
            this.hierarchyLevelElements = new Array(
              this.hierarchyLevels.length
            ).fill([]);
          }
          BackendServices.getProductHierarchyLevelElements(
            this.classificationLevel.id > 0 ? this.classificationLevel.id : null
          ).then(response => {
            this.hierarchyLevelElements.splice(
              this.classificationLevel,
              1,
              response.data
            );
          });
        });
      }
    }
  }
};
